export const Routing = {
	main: {
		start: '/',
		reportDamage: '/zgloszenie',
		documents: '/dokumenty',
		faq: '/faq',
		form: '/formularz',
		formSuccess: '/sukces',
		paymentSuccess: '/koniec',
	},
};
